/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'underscore'
], function (Class, _) {
	'use strict';

	var GridDataProvider = Class.extend({

		_data: null,
		_numRows: null,
		_numColumns: null,

		init: function (data) {
			if(data) {
				this._data = data;
				this._setDataDimensions();
			}
		},

		getNumRows: function () {
			return this._numRows;
		},

		getNumColumns: function () {
			return this._numColumns;
		},

		getValue: function (rowIndex, columnIndex) {
			return this._data[rowIndex][columnIndex];
		},

		_setDataDimensions: function () {
			if (this._data) {
				this._numRows = this._data.length;
				this._numColumns = _.isArray(this._data[0]) ? this._data[0].length : 0;
			}
		},

		updateData: function (data) {
			if(data) {
				this._data = data;
				this._setDataDimensions();
			}
		}
	});

	return GridDataProvider;
});
